import React, { createContext, Context, useState, PropsWithChildren, FC, useEffect, useRef }  from 'react';


export enum ThemeEnum {
    light,
    dark
}

export type ThemeContextType = {
    theme: ThemeEnum,
    toggleTheme: () => void
}

export const ThemeContext : Context<object> = createContext({});

const ThemeContextProvider: FC<PropsWithChildren> = ({children}) => {
    const [theme, setTheme] = useState<ThemeEnum>(ThemeEnum.dark);
    const toggleTheme = () => {
        localStorage.setItem('Theme', theme === ThemeEnum.light ? 'dark' : 'light');
        if(theme === ThemeEnum.dark) setTheme(ThemeEnum.light);
        else if(theme === ThemeEnum.light) setTheme(ThemeEnum.dark);
        return
    }
    useEffect(() => {
        const stored_theme = localStorage.getItem('Theme');
        if(stored_theme != undefined){
            if(stored_theme === 'light') setTheme(ThemeEnum.light);
            else if(stored_theme === 'dark') setTheme(ThemeEnum.dark);
        }
        else localStorage.setItem('Theme', theme === ThemeEnum.light ? 'dark' : 'light');
    }, [])
    return (
        <ThemeContext.Provider value={{theme: theme, toggleTheme: toggleTheme}}>{children}</ThemeContext.Provider>
    )
}

export default ThemeContextProvider;